import { render, staticRenderFns } from "./PDFPage.vue?vue&type=template&id=0889348e"
import script from "./PDFPage.vue?vue&type=script&lang=js"
export * from "./PDFPage.vue?vue&type=script&lang=js"
import style0 from "./PDFPage.vue?vue&type=style&index=0&id=0889348e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports